import React from 'react';

import RateTrendsEdit from './RateTrendsEdit';
import EditModalControl from '../../common/edit/EditModalControl';

interface Props {
  type: 'button' | 'link';
  show?: boolean;
  buttonDataTestId?: string;
  linkDataTestId?: string;
  onSuccess: () => void;
}

const RateTrendsEditModal = ({ type, show, buttonDataTestId, linkDataTestId, onSuccess }: Props) => (
  <EditModalControl
    type={type}
    title={'Edit Rate Trends'}
    show={show}
    buttonDataTestId={buttonDataTestId}
    linkDataTestId={linkDataTestId}
    onSuccess={onSuccess}
  >
    <RateTrendsEdit />
  </EditModalControl>
);

export default RateTrendsEditModal;
